import { render, staticRenderFns } from "./back-btn.vue?vue&type=template&id=c8ba6648&scoped=true"
import script from "./back-btn.vue?vue&type=script&lang=js"
export * from "./back-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ba6648",
  null
  
)

export default component.exports